module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// A:/CM/links-ui/cm-ui-app-links/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main